export default {
  default: '#3C3C3B',
  orange: '#F28E00',
  secondary: '#2B2E34',
  white: '#ffffff',
  grayDark: '#BDBDBD',
  grayLight: '#ECECEC',
  footerBg: '#8D8D8D',
}